module.exports = __webpack_public_path__ + "img/item6.e8cca662.png";